import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import posthog from '../../lib/posthog';

export default function PostHogPageViewTracker() {
    const { pathname } = useLocation();

    useEffect(() => {
        posthog.capture('$pageview');
    }, [pathname]);

    return null;
}
